module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start06_01-0398a5b88168777b95c7904e58f87b8d.gif";